<template>
  <div class="printable-content simple-paper text-sm">
    <!-- header informations -->
    <div class="grid grid-cols-2 mb-8 border-b border-slate-300 pb-4">
      <!-- uttrly informations -->
      <div>
        <div class="mb-4">
          <span class="block font-bold text-md mb-3">Uttrly</span>
          <span class="block mb-2">11810 Grand Park Ave, Suite 500</span>
          <span class="block mb-2">North Bethesda, MD 20852</span>
          <span class="block mb-2">202.681.0825</span>
          <span class="block">portal-admin@uttrly.com</span>
        </div>

        <div class="text-primary-700 font-semibold mb-4 text-2xl">
          <span class="uppercase">Invoice</span>
        </div>

        <div class="text-base font-semibold mb-2">
          <span class="uppercase">Bill to</span>
        </div>

        <!-- customer informations -->
        <div>
          <span v-if="customer?.name" class="block mb-1">{{ customer.name }}</span>
          <span v-if="customer?.address" class="block mb-1">{{ customer.address }}</span>
        </div>
      </div>

      <!-- logo and invcoie header informations -->
      <div>
        <div class="flex justify-end mb-7">
          <img
            :src="logo"
            alt="Uttrly"
          />
        </div>
        <div class="text-right">
          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">Invoice #</span>
            <span>{{ invoice.invoiceId }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">DATE</span>
            <span>{{ getLocalDate(invoice.invoiceDate) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3 uppercase">Due DATE</span>
            <span>{{ getLocalDate(invoice.dueDate) }}</span>
          </div>

          <div class="grid grid-cols-4 gap-2">
            <span class="font-bold col-span-3">TERMS</span>
            <span>Net 30</span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <BaseTable
        :items="invoice.items"
        :fields="invoiceItemFields"
        :show-footer="true"
        class="mt-5"
      >
        <template #unitPrice-data="{ row }">
          {{ currency(row.unitPrice) }}
        </template>

        <template #total-header="{ column }">
          <span class="block text-center">{{ column.label }}</span>
        </template>

        <template #total-data="{ row }">
          <span class="block text-center">{{ currency(row.total) }}</span>
        </template>

        <template #footer>
          <div class="flex items-center justify-between gap-2">
            <div class="flex-grow">
              <span class="text-slate-500 text-xs">Thank you for your business and have a great day</span>
            </div>

            <div>
              <div class="flex items-center justify-end gap-2">
                <span class="font-bold uppercase">Balance due:</span>
                <span>{{ currency(invoice.balance) }}</span>
              </div>
            </div>
          </div>
        </template>
      </BaseTable>
    </div>
  </div>
</template>

<script lang="ts" setup>
import logo from '@/assets/images/logo.png'
import { Customer } from '@/models/customer'
import { Invoice } from '@/models/invoice'
import { currency, getLocalDate } from '@/utils'
import { PropType } from 'vue'
import BaseTable from '@/components/base/BaseTable.vue'

const invoiceItemFields = [
  { key: 'title', label: 'DESCRIPTION' },
  { key: 'quantity', label: 'QTY' },
  { key: 'unitPrice', label: 'RATE' },
  { key: 'total', label: 'AMOUNT' }
]

defineProps({
  customer: {
    type: Object as PropType<Customer>,
    required: true
  },
  invoice: {
    type: Object as PropType<Invoice>,
    required: true
  },
})
</script>



<style lang="scss" scoped>
.printable-content {
  width: 200mm !important; /* Largeur A4 */
  padding: 5mm !important; /* Marges */
  /* min-height: 257mm !important; Hauteur A4 */
  background: white;
}

.simple-paper {
  border: 0.7px solid #ccc;
  padding: 20px;
}
</style>
